
const VEHICLE = {
  TYPES: ['Motorbike', 'Van', 'Truck', 'Others'],
  OWNERS: ['Shopee', 'Lease', 'Driver'],
  STATUS: ['Available', 'Unavailable'],
  STATUS_CLASS: ['success', 'disabled']
}

const STATION = {
  STATUS: ['In Operation', 'Not In Operation'],
  STATUS_CLASS: ['success', 'disabled'],
  TYPES: ['Sortation Centre', 'Self Pickup', 'Distribution Point']
}

const FLEET_ORDER = {
  STATUS: [
    'Created',
    'Pending',
    'Assigned',
    'Canceled',
    'Delivered',
    'On Hold',
    'Returned',
    'Pending Receive'
  ],
  STATUS_CLASS: [
    'disabled',
    'warning',
    'warning',
    'danger',
    'success',
    'warning',
    'disabled',
    'warning'
  ]
}

const ON_HOLD_REASON = [
  'Normal',
  'Incomplete Address',
  'Address does not match',
  'Inaccessible Location',
  'Buyer not on Location',
  'No payment receive(COD)',
  'Misroute',
  'Insufficient Time',
  'Item lost',
  'Damaged item',
  'Disaster',
  'Rejected by buyer',
  'Buyer Re-Schedule'
]

const USER = {
  STATUS: ['Normal', 'Disabled'],
  STATUS_CLASS: ['success', 'disabled']
}

const USER_FLAG = {
  STATUS: ['Normal', 'Admin'],
  STATUS_CLASS: ['success', 'danger']
}

const ROLE = {
  STATUS: ['Normal', 'Disabled'],
  STATUS_CLASS: ['success', 'disabled']
}

const DRIVER = {
  STATUS: ['Normal', 'Disabled'],
  STATUS_CLASS: ['success', 'disabled']
}

const RECEIVE = {
  STATUS: ['Created', 'Pending Receive', 'Received'],
  STATUS_CLASS: ['disabled', 'warning', 'success']
}

export {
  VEHICLE,
  STATION,
  FLEET_ORDER,
  USER,
  USER_FLAG,
  ROLE,
  DRIVER,
  RECEIVE,
  ON_HOLD_REASON
}



// WEBPACK FOOTER //
// ./examples/helper/valueMap.js